// removed by extract-text-webpack-plugin
module.exports = {"banner":"afKBYYXzqZl7z_gea5scQ","logo":"_2mdsWwQ2C8u072oFv89GXZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/style.css
// module id = 666
// module chunks = 0